var _defs, _rect, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionRadial6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 400,
    viewBox: "0 0 1200 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "spot",
    cx: 0.7,
    cy: 0.2,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--color-primary, #1FE1FF)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "var(--color-secondary, #8B6CFF)",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 400,
    rx: 6,
    fill: "url(#spot)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 600 200; 360 600 200",
    dur: "40s",
    repeatCount: "indefinite"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionRadial6);
export default __webpack_public_path__ + "static/media/section-radial-6.a55807435065ef6a26b6c5686d3eb807.svg";
export { ForwardRef as ReactComponent };